import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { Field } from 'redux-form';
import { Breadcrumb, Grid, Button, ButtonToolbar, Panel } from 'react-bootstrap';
import { Translate, Localize } from 'react-redux-i18n';
import Calendar from '../Common/calendar';
import { getFromToDates } from '../Common/cleanDates';
import { companyCodeTitle } from '../../actions/root_url';

class PriceAdjustmentReport extends Component {
  constructor() {
    super();
    this.state = {
      priceAdjustment: null
    }
  }
  componentDidMount() {
    document.title = companyCodeTitle;
    const dates = getFromToDates(new Date(), 'month');
    this.props.fetchPriceAdjustment('month', dates);
  }
  componentWillReceiveProps(nextProps) {
    if(nextProps.priceAdjustment && nextProps.priceAdjustment != this.props.priceAdjustment) {
      this.setState({priceAdjustment: nextProps.priceAdjustment});
    }
  }
  render() {
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="purchase_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="price_reference" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <ButtonToolbar>
          <Button
            bsStyle="primary"
            type="button">
            <em className="fa fa-print" /><Translate value="print" />
          </Button>
          <Button
            bsStyle="success"
            type="button">
            <em className="fa fa-download" /><Translate value="export" />
          </Button>
        </ButtonToolbar>
        <Grid id="price-adjustment">
          <Panel className="position-relative">
            <h1><Translate value="price_reference_chart" /></h1>
            <Field name="Calendar" component={Calendar} data={this.state.priceAdjustment} fetchInfo={this.props.fetchPriceAdjustment} type="priceAdjustment" url="/priceAdjustmentDetail"/>
          </Panel>
        </Grid>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default PriceAdjustmentReport;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/priceAdjustment.jsx